// import * as React from 'react'
import styled from 'styled-components'
import {devices} from '../../components/MediaQuerys/BreakpointsAndDevices'

const GlobaContainer = styled.div`
    
    // display: flex;
    // justify-content: center;
    border-radius: 10px;
    border-radius: 0 0 1em 1em;
    margin: 0 auto;
    width: auto;
    transition: all 1s ease-in-out;
    @media only screen and ${devices.mobileS} {
        width:320px;
        
    }
    @media only screen and ${devices.mobileM} {
        width:98%;
        
    }
    @media only screen and ${devices.tablet} {
        min-width: 780px;
    }
    @media only screen and ${devices.laptop}{
        width: 98%;

    }
    @media only screen and ${devices.laptopL}{
        width:1440px;

    }
` 
// Header Container
const HeaderContainerComponent = styled.div`

    display: grid;
    grid-auto-flow: column;
    background-color: #4895b7;
    justify-items: center;
    align-content: center;
    margin: 0 auto;
    height: 8em;
`;

export const HeaderContainer = (props)=>{
    return(
        <GlobaContainer>
            <HeaderContainerComponent>
                {props.children}
            </HeaderContainerComponent>
        </GlobaContainer>
    )
}
// Navbar Container
const NavbarContainerComponent = styled.div`
    margin: 0 auto;
    max-width: 1280px;
    // background-color: #4895b7;
    height:70px;
    display: grid;
    align-items: center;
    justify-content: center;
    grid-auto-flow: column;
    overflow-x: hidden;
    white-space: nowrap; 
    @media only screen and ${devices.mobileS} {
        max-width:280px;
    }
    @media only screen and ${devices.mobileM} {
        max-width:375px;
    }
    @media only screen and ${devices.tablet} {
        max-width:768px;
    }
    @media only screen and ${devices.laptop}{
        max-width:1200px;
    }
`;
export const NavbarContainer = (props)=>{
    return(
        <NavbarContainerComponent>
            {props.children}
        </NavbarContainerComponent>
    )
}
// Page Container
const PageContainerComponent = styled.section`
    // display: grid;
    // justify-content: center;
    // align-items: center;
    width: auto;
    white-space: nowrap;
    display: grid;
    justify-content: center;
    align-items: center;
    // overflow-x: hidden;
    /* min-height: calc(100vh - 20rem);
    max-height: max-content; */
    margin: 0 auto;
    transition: all 1s ease-in-out;

`
export const PageContainer = (props)=>{
    return(
        <PageContainerComponent>
            {props.children}
        </PageContainerComponent>
    )
}
// Double Container
const DoubleContainerComponent = styled.div`
    display: grid;
    justify-content: end;
    align-items: center;
    margin: 0 auto;
    grid-template-columns: 1fr 1fr;
    row-gap: 20px;
    column-gap: 10px;
    width: 100%;
`
export const DoubleContainer = (props)=>{
    return(
        <DoubleContainerComponent>
            {props.children}
        </DoubleContainerComponent>
    )
}
// Single Container
const SingleContainerComponent = styled.div`
    display: grid;
    justify-content: center;
    align-items: start;
    grid-auto-flow: column;
    column-gap: 10px;
    margin: 20px 0 20px 0;
    width: 100%;
`
export const SingleContainer = (props)=>{
    return(
        <SingleContainerComponent>
            {props.children}
        </SingleContainerComponent>
    )
}// Single Container
const CardContainerComponent = styled.div`
    display: grid;
    grid-template-columns: 380px 380px 380px;
    column-gap: 30px;
    row-gap: 30px;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    width: 100%;

`
export const CardContainer = (props)=>{
    return(
        <CardContainerComponent>
            {props.children}
        </CardContainerComponent>
    )
}
// Footer Container
const FooterContainerComponent = styled.div`
    /* align-items: end; */
    border-top: solid 5px #10609A;
    display: grid;
    column-gap: 20%;
    grid-auto-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 14vh;
    @media only screen and ${devices.mobileS} {
        width: 320px;
        
    }
    @media only screen and ${devices.mobileM} {
        width: 98%;
        
    }
    @media only screen and ${devices.tablet} {
        max-width: 100%;
    }
    @media only screen and ${devices.laptop}{
        /* min-width: 1024px; */
        width: 100%;

    }
    @media only screen and ${devices.laptopL}{
        max-width: 100%;

    }
`
export const FooterContainer = (props)=>{
    return(
        <FooterContainerComponent>
            {props.children}
        </FooterContainerComponent>
    )
}
